/**
 * First-party WAM bundle.
 *
 * Everything listed here is registered at engine boot via
 * `registerWams(ctx, WAM_BUNDLE)`. Phase C seeds the bundle with a
 * first round of effect WAMs whose MIT/Apache licenses are
 * compatible with our distribution. Instrument WAMs (Obxd, FM
 * synths) are out of scope until the instrument adapter ships —
 * instrument descriptors get a warn-log and are skipped by the
 * registry.
 *
 * URLs currently point at origin-relative paths under
 * `/wam/<id>/index.js` — the Vite dev server resolves those to
 * `packages/app/public/wam/<id>/`. Drop the WAM's distribution files
 * there and the preload succeeds. If the directory is empty the
 * preload's `import()` returns a 404; `WamEffectAdapter` falls back
 * to a pass-through slot, so the app keeps running. See
 * `public/wam/README.md` for the vendor workflow.
 *
 * To add a descriptor:
 *   1. Confirm the WAM's license is in `BUNDLABLE_LICENSES` (MIT /
 *      BSD / Apache-2.0). GPL and custom-license entries must route
 *      through the BYO loader (future work).
 *   2. Vendor the bundle under `packages/app/public/wam/<id>/` or
 *      verify a CORS-enabled stable CDN URL.
 *   3. Add a `WamDescriptor` entry here.
 *   4. Add a matching `PluginCatalogEntry` in
 *      `packages/shared/src/constants/plugins.ts` so the Store + FX
 *      picker show it.
 */

import type { WamDescriptor } from './registry'

export const WAM_BUNDLE: readonly WamDescriptor[] = [
  // ── Effect: WAM-Pingo (stereo ping-pong delay) ─────────
  // Upstream: https://github.com/webaudiomodules/pingo (MIT)
  // Fills a gap in our first-party catalog — the built-in delay is
  // mono; Pingo is stereo with sync. Bundle drop target:
  //   packages/app/public/wam/pingo/index.js
  {
    id: 'wam-pingo',
    url: '/wam/pingo/index.js',
    kind: 'effect',
    label: 'WAM Pingo',
    category: 'time',
    license: 'MIT',
    description: 'Stereo ping-pong delay with tempo sync (WAM v2).',
  },
]
